/**
 * SwUpdateBanner — Sprint 19 · P2.1 rebrand (2026-05-28)
 *
 * Aviso suave cuando hay nueva versión del Service Worker. NO fuerza reload ·
 * el usuario confirma. Antes era fondo negro sobre app cream (rompía paleta);
 * ahora consume tokens del Design System V2:
 *   - bg cream-soft + border + sombra
 *   - texto ink-soft
 *   - "Actualizar" = Button primary (terracota)
 *   - "Ahora no" = Button text terracota
 */

import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

export default function SwUpdateBanner() {
  const [registration, setRegistration] = useState(null)
  const [dismissed, setDismissed]       = useState(false)

  useEffect(() => {
    const handleUpdate = (e) => setRegistration(e.detail?.registration)
    window.addEventListener('sw-update-ready', handleUpdate)
    return () => window.removeEventListener('sw-update-ready', handleUpdate)
  }, [])

  const handleUpdate = () => {
    if (!registration?.waiting) return
    registration.waiting.postMessage({ type: 'SKIP_WAITING' })
    setRegistration(null)
  }

  const show = !!registration && !dismissed

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          role="status"
          aria-live="polite"
          initial={{ opacity: 0, y: -40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -40 }}
          transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
          style={{
            position: 'fixed',
            top: 0, left: 0, right: 0,
            zIndex: 10000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 'var(--pl-space-3, 12px)',
            padding: '10px var(--pl-space-gutter, 16px)',
            // P2.1 fix · cream-soft sobre app cream · NO negro sobre cream
            background: 'var(--pl-cream-soft, #F4F0E8)',
            color: 'var(--pl-ink-soft, #3D3935)',
            borderBottom: '1px solid var(--pl-border, #E8E2D5)',
            boxShadow: '0 2px 8px rgba(75, 56, 38, 0.06)',
            fontFamily: 'var(--pl-font-sans, Inter, system-ui, sans-serif)',
            fontSize: 14,
            fontWeight: 500,
            paddingTop: 'calc(10px + env(safe-area-inset-top))',
            paddingLeft: 'calc(var(--pl-space-gutter, 16px) + env(safe-area-inset-left))',
            paddingRight: 'calc(var(--pl-space-gutter, 16px) + env(safe-area-inset-right))',
          }}
        >
          <span style={{ flex: 1, minWidth: 0 }}>
            Hay una versión nueva de PrimeLab
          </span>
          <div style={{ display: 'flex', gap: 'var(--pl-space-2, 8px)', flexShrink: 0 }}>
            <button
              type="button"
              onClick={handleUpdate}
              style={{
                minHeight: 36,
                padding: '8px 14px',
                borderRadius: 'var(--pl-radius-md, 12px)',
                border: 'none',
                background: 'var(--pl-terracota, #CC785C)',
                color: 'var(--pl-terracota-on, #FAF9F5)',
                fontSize: 13,
                fontWeight: 600,
                letterSpacing: '-0.005em',
                cursor: 'pointer',
                fontFamily: 'inherit',
                boxShadow: 'var(--pl-shadow-xs)',
                transition: 'background var(--pl-dur-fast, 200ms) var(--pl-ease-out, ease-out)',
              }}
            >
              Actualizar
            </button>
            <button
              type="button"
              onClick={() => setDismissed(true)}
              style={{
                minHeight: 36,
                padding: '8px 12px',
                borderRadius: 'var(--pl-radius-md, 12px)',
                border: 'none',
                background: 'transparent',
                color: 'var(--pl-terracota-700, #A55B41)',
                fontSize: 13,
                fontWeight: 500,
                cursor: 'pointer',
                fontFamily: 'inherit',
              }}
            >
              Ahora no
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
